/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Knp_Terms_Imported_TermsInputs */

const en_knp_terms_imported_terms = /** @type {(inputs: Knp_Terms_Imported_TermsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Imported ${i?.count} terms`)
};

const fr_knp_terms_imported_terms = /** @type {(inputs: Knp_Terms_Imported_TermsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importation de ${i?.count} termes`)
};

const de_knp_terms_imported_terms = /** @type {(inputs: Knp_Terms_Imported_TermsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importierte ${i?.count} Begriffe`)
};

const it_knp_terms_imported_terms = /** @type {(inputs: Knp_Terms_Imported_TermsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Termini importati ${i?.count}`)
};

const ru_knp_terms_imported_terms = /** @type {(inputs: Knp_Terms_Imported_TermsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Импортированные термины ${i?.count}`)
};

const es_knp_terms_imported_terms = /** @type {(inputs: Knp_Terms_Imported_TermsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Términos ${i?.count} importados`)
};

const zh_cn2_knp_terms_imported_terms = /** @type {(inputs: Knp_Terms_Imported_TermsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`导入的${i?.count}条款`)
};

const ja_knp_terms_imported_terms = /** @type {(inputs: Knp_Terms_Imported_TermsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`インポートされた${i?.count}用語`)
};

const hi_knp_terms_imported_terms = /** @type {(inputs: Knp_Terms_Imported_TermsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`आयातित ${i?.count} शर्तें`)
};

const pt_pt2_knp_terms_imported_terms = /** @type {(inputs: Knp_Terms_Imported_TermsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Termos importados ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Imported {count} terms" |
*
* @param {Knp_Terms_Imported_TermsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_imported_terms = /** @type {((inputs: Knp_Terms_Imported_TermsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Imported_TermsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_terms_imported_terms(inputs)
	if (locale === "de") return de_knp_terms_imported_terms(inputs)
	if (locale === "it") return it_knp_terms_imported_terms(inputs)
	if (locale === "ru") return ru_knp_terms_imported_terms(inputs)
	if (locale === "es") return es_knp_terms_imported_terms(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_terms_imported_terms(inputs)
	if (locale === "ja") return ja_knp_terms_imported_terms(inputs)
	if (locale === "hi") return hi_knp_terms_imported_terms(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_terms_imported_terms(inputs)
	return en_knp_terms_imported_terms(inputs)
});